<!-- NOT-FOUND PAGE -->
<section class="notfound">
  <div class="error-container">
    <div class="error-content">
      <h1 class="error-code">404</h1>
      <h2 class="error-message">Page Not Found</h2>
      <p class="error-description">Sorry, we cant find the page you're looking for.</p>
      <div class="action-button">
        <a routerLink="/home" class="btn btn-primary larger-btn padding-right-small">
          Go to Home
        </a>
      </div>
    </div>
  </div>
</section>
<!--END NOT-FOUND PAGE-->
